import spielographerP from "./spielographerP.png";

export const ONE_ARMED_SCISSOR_PORTRAIT_IMAGES_POSTS = [spielographerP];
